import slidingPuzzleQuestIcon from "../../assets/app-icons/sliding-puzzle-quest-app-icon.png";
import {
    JIGSAW_MUSE_GOOGLE_PLAY_URL,
    SHOW_JIGSAW_GOOGLE_PLAY_BADGE,
    SHOW_SLIDING_GOOGLE_PLAY_BADGE,
    SHOW_WORD_WHEEL_APP_STORE_BADGE,
    SHOW_WORD_WHEEL_GOOGLE_PLAY_BADGE,
    SLIDING_PUZZLE_QUEST_GOOGLE_PLAY_URL,
    WORD_WHEEL_QUEST_APP_STORE_URL,
    WORD_WHEEL_QUEST_GOOGLE_PLAY_URL,
} from "../../config/nativeAppsVisibility";

const PUBLIC = process.env.PUBLIC_URL || "";

/**
 * Google Play titles shown on the landing showcase, in display order.
 * Copy keys fall back to English so untranslated packs still read correctly.
 */
const ANDROID_APPS = [
    {
        id: "jigsaw",
        name: "Jigsaw Muse",
        badge: "Color Sorting",
        badgeTheme: "green",
        descriptionKey: "landingApp.app-jigsaw-desc",
        description:
            "Sort pieces into color baskets first, then watch them snap home on big photo puzzles.",
        iconUrl: `${PUBLIC}/ad/jigsaw-muse-app-icon-512.png`,
        playUrl: JIGSAW_MUSE_GOOGLE_PLAY_URL,
        visible: SHOW_JIGSAW_GOOGLE_PLAY_BADGE,
    },
    {
        id: "word-wheel",
        name: "Word Wheel Quest",
        badge: "Word Challenge",
        badgeTheme: "blue",
        descriptionKey: "landingApp.app-word-wheel-desc",
        description:
            "Spin a wheel of letters and uncover every hidden word, with hints when a round stalls.",
        iconUrl: `${PUBLIC}/ad/word-wheel-quest-app-icon-512.png`,
        playUrl: WORD_WHEEL_QUEST_GOOGLE_PLAY_URL,
        appStoreUrl: SHOW_WORD_WHEEL_APP_STORE_BADGE ? WORD_WHEEL_QUEST_APP_STORE_URL : "",
        visible: SHOW_WORD_WHEEL_GOOGLE_PLAY_BADGE || SHOW_WORD_WHEEL_APP_STORE_BADGE,
    },
    {
        id: "sliding",
        name: "Sliding Puzzle Quest",
        badge: "Tile Logic",
        badgeTheme: "orange",
        descriptionKey: "landingApp.app-sliding-desc",
        description:
            "Slide tiles back into place across story boards that grow from gentle 3×3 warm-ups to expert grids.",
        // Current store icon, shared with the featured hero and YouTube cover art.
        iconUrl: slidingPuzzleQuestIcon,
        playUrl: SLIDING_PUZZLE_QUEST_GOOGLE_PLAY_URL,
        visible: SHOW_SLIDING_GOOGLE_PLAY_BADGE,
    },
];

/** Titles whose Play badge is enabled for marketing surfaces. */
export function getVisibleAndroidApps() {
    return ANDROID_APPS.filter((app) => app.visible && (app.playUrl || app.appStoreUrl));
}

/** App the hero badge installs — the word-logic title the hero headline speaks to. */
export const HERO_APP_ID = "word-wheel";

/** Hero badge target, falling back to the first visible title. */
export function getHeroApp() {
    const visible = getVisibleAndroidApps();
    return visible.find((app) => app.id === HERO_APP_ID) ?? visible[0] ?? null;
}

export default ANDROID_APPS;
